import _ from 'lodash';
import MemberService from 'web-core/src/member-service';
import IfpAppService from 'web-core/src/ifp-app-service';
import { updateApp } from 'client/actions/ifpApps';

import type { UserType } from 'web-core/types/user';
import type { MemberType } from 'web-core/types/member';

export const RECEIVE_MEMBERS = 'RECEIVE_MEMBERS';
export const SAVE_MEMBERS = 'SAVE_MEMBERS';
export const UPDATE_MEMBERS = 'UPDATE_MEMBERS';
export const DELETE_MEMBER = 'DELETE_MEMBER';

export const receiveMembers = data => ({
  type: RECEIVE_MEMBERS,
  data,
});

export const saveLatestMembers = data => ({
  type: SAVE_MEMBERS,
  data,
});

export const updateLatestMembers = data => ({
  type: UPDATE_MEMBERS,
  data,
});

const memberDeleted = id => ({
  type: DELETE_MEMBER,
  data: { id },
});

export const fetchMembers = () => (dispatch, getState, { apiClient }) => {
  const svc = new MemberService({ client: apiClient });
  return svc.getMembers().then((response) => {
    dispatch(receiveMembers(response));
    return response;
  });
};

export const updateMembers = (members: Array<MemberType>) => (dispatch) => {
  dispatch(updateLatestMembers(members));
};

export const saveMembers = (members: Array<MemberType>) => (dispatch, getState, { apiClient }) => {
  const svc = new MemberService({ client: apiClient });
  return svc.saveMembers(members).then((response) => {
    dispatch(saveLatestMembers(response));
    return response;
  });
};

export const putMembers = (members: Array<MemberType>) => (dispatch, getState, { apiClient }) => {
  const svc = new MemberService({ client: apiClient });
  return svc.saveMembers(members).then((response) => {
    dispatch(updateMembers(response));
    return response;
  });
};

export const deleteMember = (id: string, removalReason: string, removalDate: Date) => (dispatch, getState, { apiClient }) => {
  const svc = new MemberService({ client: apiClient });
  return svc.deleteMember(id, removalReason, removalDate).then(() => dispatch(memberDeleted(id)));
};

// TODO: Why doesn't this use web-core member service saveMembersToApp?
// The two methods point to the same API endpoint and seem to do the same thing
export const saveMembersToApp = (members: Array<MemberType>, appId: string, user: UserType) => (
  dispatch,
  getState,
  { apiClient },
) => {
  // $FlowFixMe
  if (user && !user.isLoggedIn) {
    dispatch(updateApp(appId, { members }));
    return Promise.resolve({ members });
  }

  const svc = new IfpAppService({ client: apiClient });

  const membersMap = members.map((member) => {
    const status = member.status
      ? member.status
      : _.get(member, 'member_application.type', 'coverage');
    return { ...member, status };
  });

  return svc.saveMembers(membersMap, { app_id: appId }).then((response) => {
    const updatedMembers = { members: response.members };
    dispatch(updateApp(appId, updatedMembers));
    dispatch(saveLatestMembers(response));
    return response;
  });
};
